import { render, staticRenderFns } from "./OrderSummaryItemView.vue?vue&type=template&id=55b6bb8d&scoped=true&"
import script from "./OrderSummaryItemView.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryItemView.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryItemView.vue?vue&type=style&index=0&id=55b6bb8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b6bb8d",
  null
  
)

export default component.exports